module.exports = __webpack_public_path__ + "img/trio-page-7-elisse.c3bd8e2b.jpg";